import * as React from 'react';
import {withRouter} from "react-router";
import {RootState} from "../../../../store/reducer/root/RootState";
import {Dispatch} from "redux";
import {connect} from "react-redux";
import CommonStreamItem, {StreamItemAction} from "../../../../hiberUiKit/src/molecules/StreamItem/CommonStreamItem";
import JobMarkedAsPaidEvent from "../../../../model/job/event/JobMarkedAsPaidEvent";
import {getInvoiceByJobId} from "../../../../store/view/invoice";
import {getBillByJobId} from "../../../../store/view/bill";
import {InvoiceStatus} from "../../../../model/invoice/Invoice";
import {getJobByIdOrRefNumber} from "../../../../store/view/job";
import {JobInvoicePath} from "../../../../model/job/JobInvoicePath";
import {JobEventTypeEnum} from "../../../../model/job/event/JobEvent";
import ActivityStreamUtils from "../../../../utils/ActivityStreamUtils";
import {unmarkedAsPaid} from "../../../../store/action/job/job";
import {OnFailure, OnSuccess} from "../../../../store/action/actionHelpers";
import Toast from "../../../helper/Toast";
import {notifyBugsnagAndShowToast} from "../../../../utils/Utils";

interface ReduxProps {
	isUnmarkedAsPaidVisible: boolean
}

interface ComponentProps {
	/**
	 * Job activity to display.
	 */
	activity: JobMarkedAsPaidEvent;
}

interface DispatchProps {
	unmarkedJobAsPaid: (jobId: string, onSuccess: OnSuccess, onFailure: OnFailure) => void
}

type Props = ComponentProps & ReduxProps & DispatchProps;

class JobActivityMarkAsPaidItem extends React.PureComponent<Props> {

	render() {
		const actions: StreamItemAction[] = [];
		if (this.props.isUnmarkedAsPaidVisible) {
			actions.push(StreamItemAction.new("Unmark As Paid",
				() => this.props.unmarkedJobAsPaid(this.props.activity.jobId,
					() => Toast.success("Job unmarked as paid successfully", "Unmarked Job As Paid"),
					e => notifyBugsnagAndShowToast(e, "Unmarked Job As Paid"))));
		}
		return (
			<CommonStreamItem event={this.props.activity}
							  actions={actions}/>
		);
	}
}

function mapStateToProps(state: RootState, props: ComponentProps) {
	const invoice = getInvoiceByJobId(props.activity.jobId, state);
	const bill = getBillByJobId(props.activity.jobId, state);
	const job = getJobByIdOrRefNumber(props.activity.jobId, state);

	const [lastMarkedAsPaidEvent] = state.job.events.getOrElse([]).filter(
		e => e.jobId == props.activity.jobId && e.type == JobEventTypeEnum.MarkedAsPaid)
		.sort(ActivityStreamUtils.sort);

	const isUnmarkedAsPaidVisible = lastMarkedAsPaidEvent && lastMarkedAsPaidEvent.id == props.activity.id
		&& invoice.map(i => i.status == InvoiceStatus.Paid).getOrElse(false)
		&& bill.map(b => !b.isPaid()).getOrElse(false)
		&& job.flatMap(j => j.data.invoicePath)
			.map(ip => ip == JobInvoicePath.BILL || ip == JobInvoicePath.FULL_SERVICE)
			.getOrElse(false)

	return {
		isUnmarkedAsPaidVisible
	}
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		unmarkedJobAsPaid: (jobId: string, onSuccess: OnSuccess, onFailure: OnFailure) => dispatch(
			unmarkedAsPaid(jobId, onSuccess, onFailure))
	}
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(JobActivityMarkAsPaidItem));